import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import Footer from './Footer';
import Header from './Header';
import Home from './Home';
import { useEffect } from 'react';
import Contact from './Contact';
import Privacy from './Privacy';
import Pictures from './Pictures';
import Music from './Music';
import Live from './Live';
import Band from './Band';

function App() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
      window.scrollTo({ top: 0/*, behavior: 'smooth'*/ });
  }, [pathname]);

  useEffect(() => {
    const { hash, pathname } = window.location;

    // Check if the hash contains 'invite_token' and we're not already on '/admin'
    if (hash.includes('invite_token') && pathname !== '/admin') {
      // Redirect to '/admin' with the existing hash
      window.location.replace(`/admin/${hash}`);
    }
  }, [pathname]);

  return (
    <div className="App">
      <Header />

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/band' element={<Band />} />
        <Route path='/music' element={<Music />} />
        <Route path='/live' element={<Live />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/privacy' element={<Privacy />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
